<template>
  <Container :class="$style.container">
    <Grid>
      <GridItem
        :class="$style.center"
        :gridSpan="11"
      >
        <Icon
          icon="chat"
          inline
        />
        <HeadingSmall :class="$style.inline">
          Have more questions? Reach out to our Professional Services team.
        </HeadingSmall>
      </GridItem>
      <GridItem :gridSpan="1">
        <Button
          hasOutline
          text="Contact"
          type="secondary"
          @click="handleContact"
        />
      </GridItem>
    </Grid>
  </Container>
</template>
<script>
import {
  Button,
  Container,
  Grid,
  GridItem,
  HeadingSmall,
  Icon,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  text,
  section,
  toUrl,
} = eventProperties;

const {
  implementationGuidesPage,
} = eventLocations;

const contactLink = 'mailto:professionalservices@jumpcloud.com';

export default {
  name: 'ContactProfessionalServices',

  EventHelper,
  Util,
  contactLink,

  components: {
    Button,
    Container,
    Grid,
    GridItem,
    HeadingSmall,
    Icon,
  },

  methods: {
    handleContact() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'contact professional services',
        [location]: implementationGuidesPage,
        [section]: 'Professional Services',
        [text]: 'Contact',
        [toUrl]: this.$options.contactLink,
      });
      this.$options.Util.openUrl(this.$options.contactLink);
    },
  },
};
</script>
<style module scoped>
.center {
  align-self: center;
}

.container {
  border: var(--jc-border);
}

.inline {
  display: inline;
}
</style>
